<template>
  <t-default-entry
    sub-heading="Sign Up"
    heading="新規お申し込み"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div v-if="error" class="t-application-invite-user-sms-verify-otp-input__alert">
      <a-alert :title="errorMessage" color="error" size="small" />
    </div>
    <div class="t-application-invite-user-sms-verify-otp-input__intro">
      <a-heading heading="SMS認証" variant="center" tag="h3"></a-heading>
      <a-text>
        「{{ phoneNumber }}」宛にSMSを送信いたしました。メッセージ内に記載されたコードを入力してください。
      </a-text>
    </div>
    <form class="t-application-invite-user-sms-verify-otp-input__form" @submit.prevent="handleFormSubmit">
      <div class="t-application-invite-user-sms-verify-otp-input__group">
        <m-form-input class="t-application-invite-user-sms-verify-otp-input__input" label="6桁の認証コード">
          <a-text-field v-model="otp" type="number" name="" placeholder="123456" />
          <template #note>
            <a-caption-list>
              <li>
                認証が失敗する場合は<a-button variant="text" color="primary" :href="recoveryUrl">こちら</a-button>
              </li>
            </a-caption-list>
          </template>
        </m-form-input>
      </div>
      <m-button-container class="t-application-invite-user-sms-verify-otp-input__buttons">
        <a-button variant="block" submit="submit" color="primary">次へ</a-button>
        <a-button variant="outlined" color="primary" @click="handleResendClick">認証コードを再送する</a-button>
        <a-button color="primary" @click="handleCancelClick">戻る</a-button>
      </m-button-container>
    </form>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';

import TDefaultEntry from '@/components/templates/default-entry';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import AHeading from '@/components/atoms/heading';
import MFormInput from '@/components/molecules/form-input';
import MButtonContainer from '@/components/molecules/button-container';
import ATextField from '@/components/atoms/text-field';
import ACaptionList from '@/components/atoms/caption-list';
import AAlert from '@/components/atoms/alert';

export default {
  name: 't-application-invite-user-sms-verify-otp-input',
  components: {
    TDefaultEntry,
    AButton,
    AHeading,
    AText,
    MFormInput,
    ATextField,
    MButtonContainer,
    ACaptionList,
    AAlert,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    recoveryUrl: {
      type: String,
      default: '#',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleSubmitClick: {
      type: Function,
      default: () => {},
    },
    handleResendClick: {
      type: Function,
      default: () => {},
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      otp: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user-sms-verify-otp-input', this.error ? 'error' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      this.handleSubmitClick(this.otp);
    },
  },
};
</script>
